import PropTypes from 'prop-types';
import Backdrop from '../Backdrop/Backdrop';
import classes from './Drawer.module.css';

const Drawer = ({ show, onClose, side, children, closeWithBackdrop }) => {
  const closeHandler = () => {
    if (closeWithBackdrop) onClose();
  };
  return (
    show && (
      <>
        <Backdrop
          show={show}
          onClose={closeHandler}
          pointerOnHover={closeWithBackdrop}
        />
        <div
          data-testid="drawer"
          className={`${classes.drawer} ${classes.open} ${classes[side]} ${
            classes[`slide-in-${side}`]
          }`}
        >
          {children}
        </div>
      </>
    )
  );
};

Drawer.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  side: PropTypes.oneOf(['right', 'left', 'top', 'bottom']),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  closeWithBackdrop: PropTypes.bool,
};

Drawer.defaultProps = {
  onClose: () => {},
  closeWithBackdrop: true,
  side: 'right',
};

export default Drawer;
